import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import materialTheme from './materialUITheme';
// eslint-disable-next-line no-unused-vars
import App from './containers/app/App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import datadogRum from './components/datadog-rum';

datadogRum.init();

// MUI adds the `Mui-focused` class to input wrappers on any focus (mouse or keyboard).
// CSS-only solutions like `:focus-visible` don't reliably suppress focus styles on
// inputs when clicked with a mouse — browsers treat inputs differently from buttons.
// To show focus indicators only during keyboard navigation, we track intent here:
// Tab key → add `keyboard-nav` to <body>, mouse click → remove it.
// All input focus styles in accessibility.scss are gated on `body.keyboard-nav`.
document.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    document.body.classList.add('keyboard-nav');
  }
});
document.addEventListener('mousedown', () => {
  document.body.classList.remove('keyboard-nav');
});

try {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <ThemeProvider theme={materialTheme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>,
  );
} catch (error) {
  // eslint-disable-next-line no-console
  console.error('Error during React app initialization:', error);
  window.location.reload(true);
}

/* root.render(
  <ThemeProvider theme={materialTheme}>
    <App />
  </ThemeProvider>,
); */

// ** IMPORTANT **
// Keep this for a bit as a reference.
// Occasionally, see some stranger errors when using React 18 createRoot(container)
//
//
// import ReactDOM from 'react-dom';
// import { ThemeProvider } from '@mui/material';
// import materialTheme from './materialUITheme';
// // eslint-disable-next-line no-unused-vars
// import App from './containers/app/App';
// import './index.css';
// import * as serviceWorker from './serviceWorker';

// ReactDOM.render(
//   <ThemeProvider theme={materialTheme}>
//     <App />
//   </ThemeProvider>,
//   document.getElementById('root'),
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
